import {sharedPoll,stopPoll} from './poll'
import {useEffect,useState} from 'react'
import {command} from './api'
import type {FilterReply} from './ticketFilters'
export const filterReplyRequest=()=>command<{replies:FilterReply[]}>('reply_snapshot')
export default function useFilterReplies(active=true,request=filterReplyRequest){
 const [replies,setReplies]=useState<FilterReply[]>([]),[error,setError]=useState('')
 useEffect(()=>{if(!active)return;let live=true;const load=async()=>{try{const r=await request();if(live){setReplies(r.replies??[]);setError('')}}catch{if(live)setError('מצב הטיוטות לא נטען. אפשר לרענן ולנסות שוב')}};void load();const timer=sharedPoll(()=>{if(document.visibilityState==='visible')void load()},5000);return()=>{live=false;stopPoll(timer)}},[active,request])
 return {replies,error}
}
